import { Box, useTheme , Button, TextField,Stack,MenuItem} from "@mui/material";
import Header from "../../../../components/global/Header";
import React, { useState, useEffect,useMemo } from 'react';
import Typography from "@mui/material/Typography";
import { tokens } from "../../../../theme";
import { useDispatch, useSelector} from "react-redux";
import NiceDate from "../../../../components/global/NiceDate";
import ProfileAvatar from "../../../../components/user/ProfileAvatar";
import { useParams,useSearchParams } from "react-router-dom"

import {getCollection} from "../../../../slices/collection"
import { setMessage, clearMessage } from "../../../../slices/message"
import { useNavigate } from "react-router-dom";
import * as yup from "yup";
import useMediaQuery from "@mui/material/useMediaQuery";

import UserService from "../../../../services/user.service";
import DisplayFormikState from "../../../../components/global/FormikHelper"
import { Formik, useField, useFormikContext } from "formik";
import { updateCollection } from "../../../../slices/collection";





const CollectionDetail = (props) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const dispatch = useDispatch();

  const {id} = useParams()

  const [admins, setAdmins] = useState([]);
  
  async function fetchUsersForCollection(collection) {

    dispatch(clearMessage());
  
      let search = {"collection":collection, "includeParentCollections":true};
  
      try{
        const data = await UserService.getUsers(search) 
        setAdmins(data.list);

      } catch (error) {
        const message =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();
        
        dispatch(setMessage(message));
  
      }
  
  }
  

  React.useEffect(() => {

    fetchUsersForCollection(id)

  }, [id]) 

  const [searchParams, setSearchParams] = useSearchParams()

  const  thisCollection  = useSelector((state) => state.collection.data.list.find(collection => collection.id === id));
  const avilableCollections = useSelector((state) => state.auth.user.collections);
  
  //remove the current collectionas it cant be a parent of its self 
  const usabeCollections = avilableCollections.filter(collection => collection.id !== id)


  useEffect(() => {

    if(!thisCollection){
      //need to get the collection to display 
      //see if its in the store
  
      dispatch(getCollection({id}));
  
    };

}, [thisCollection]);

  const getModifiedValues = (values, initialValues) => {
    let modifiedValues = {};
  
    if (values) {
      Object.entries(values).forEach((entry) => {
        let key = entry[0];
        let value = entry[1];
  
        if (value !== initialValues[key]) {
          modifiedValues[key] = value;
        }
      });
    }
  
    return modifiedValues;
  };


    var initialValues = {
      name: thisCollection?.name ,
      description: thisCollection?.description, 
      parentCollection: thisCollection?.parentCollection,
      administrator: thisCollection?.administrator,
      };



  const isNonMobile = useMediaQuery("(min-width:600px)");


  const checkoutSchema = yup.object().shape({
    name: yup.string().required("required"),
    description: yup.string().required("required"),
    administrator: yup.string().required("required"),
  });



  return (
    <>


    {thisCollection &&

    <Box m="20px" >

        <Header title={thisCollection.name} subtitle="Configgure as needed"/>

      <Box>

      

<Formik
        onSubmit={(values,actions) => {
        // this function should return the only modified values.
        const modifiedValues = getModifiedValues(values, initialValues); 

        const collection = {
          id: id,
          ...modifiedValues
        }
        dispatch(clearMessage());

        dispatch(updateCollection({collection}))
        .unwrap()
        .then(() => {
          actions.setSubmitting(false)
        })
        .catch((err) => {
          debugger;
          actions.setSubmitting(false)
        });

    }}
        validationSchema={checkoutSchema}
        initialValues={initialValues}
        enableReinitialize
      >
        {props => {
          const{
          values,
          errors,
          touched,
          handleBlur,
          handleChange,
          handleSubmit,
          handleReset,
          isSubmitting,
          isValid,
          dirty,

          } = props;
          
        return (
          <form onSubmit={handleSubmit} >

            <Box
              display="grid"
              gap="30px"
              gridTemplateColumns="repeat(4, minmax(0, 1fr))"
              sx={{
                width: 500 ,
                "& > div": { gridColumn: isNonMobile ? undefined : "span 4" },
              }}
            >

              <TextField
                fullWidth
                variant="outlined"
                type="text"
                label="Name"
                onBlur={handleBlur}
                onChange={handleChange}
                value={values.name}
                name="name"
                error={!!touched.name && !!errors.name}
                helperText={touched.name && errors.name}
                sx={{ gridColumn: "span 4" }}
                
              />
              <TextField
                fullWidth
                variant="outlined"
                type="text"
                label="Description"
                onBlur={handleBlur}
                onChange={handleChange}
                value={values.description}
                name="description"
                error={!!touched.description && !!errors.description}
                helperText={touched.description && errors.description}
                sx={{ gridColumn: "span 4" }}
              />
              
              
              <TextField
                fullWidth
                select
                variant="outlined"
                type="text"
                label="Parent Collection"
                onBlur={handleBlur}
    
                onChange={handleChange}

                value={values.parentCollection}
                name="parentCollection"
                sx={{ gridColumn: "span 2" }}
                error={touched.parentCollection && Boolean(errors.parentCollection)}
                helperText={touched.parentCollection && errors.parentCollection}
              >
                <MenuItem key="none" value={""}>
                    No Parent
                  </MenuItem>

                {usabeCollections.map((option) => (
                  <MenuItem key={option.id} value={option.id}>
                    {option.name}
                  </MenuItem>
                ))}
              </TextField>

              <TextField 
                fullWidth
                select
                variant="outlined"
                type="text"
                label="Administrator"
                onBlur={handleBlur}
                onChange={handleChange}
                value={values.administrator}
                name="administrator"

                error={touched.administrator && Boolean(errors.administrator)}
                helperText={touched.administrator && errors.administrator}
                sx={{ gridColumn: "span 2" }}
              >
                {admins.map((option) => (
                  <MenuItem key={option.usrename} value={option.username}>
                    <Box display="flex" justifyContent="start" alignItems="baseline"> 
                      <Typography display="inline" >{`${option.firstName} ${option.lastName}`}</Typography> 
                      <Typography variant="title" color="inherit" noWrap>
                        &nbsp;
                      </Typography>
                      <Typography variant="small" display="inline">{`(${option.username})`}</Typography>
                    </Box>
                  </MenuItem>
                ))}

              </TextField>
                            
              <Box display="flex" justifyContent="end" mt="20px" sx={{ gridColumn: "span 4" }}>
              <Stack direction="row" spacing={2}>

                <Button 
                  type="submit" 
                  color="secondary" 
                  variant="contained" 
                  disabled = {isSubmitting || !isValid || !dirty}
                >
                  Update Collection
                </Button>            

            </Stack>
              
            </Box>

            </Box>
              
              <DisplayFormikState {...props} />

          </form>
        )}}

      </Formik>

    </Box>      
    </Box>
}
    </>
  );
};


export default CollectionDetail;
